var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"showRulesModal",staticClass:"main-modal",attrs:{"size":"lg","ok-only":"","ok-title":"Done"}},[_c('div',{staticClass:"d-block"},[_c('rules-text')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }